import * as hash from 'hash.js';
import * as jwt_decode from 'jwt-decode'
import { AccessToken } from './access-token';
import { environment } from "../../environments/environment";

/**
 * Utility class to provide methods to Azure authentication
 */
export class AuthUtil {

  // Generate a secure random string using the browser crypto functions
  generateRandomString(): string {
    var array = new Uint32Array(28);
    window.crypto.getRandomValues(array);

    return Array.from(array, dec => ('0' + dec.toString(16)).substring(-2)).join('');
  }

  // Calculate the SHA256 hash of the input text. 
  // Returns a promise that resolves to an ArrayBuffer
  sha256(plain): string {

    let hashedValue = hash.sha256().update(plain).digest()

    return btoa(String.fromCharCode.apply(null, new Uint8Array(hashedValue)))
      .replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }

  // Base64-urlencodes the input string
  base64urlencode(str): string {
    return encodeURI(str);
  }

  // Return the base64-urlencoded sha256 hash for the PKCE challenge
  pkceChallengeFromVerifier(v): string {

    let hashed = this.sha256(v);
    return this.base64urlencode(hashed);
  }



  // Parse a query string into an object
  parseQueryString(string): any {
    if (string === "") { return {} }
    var segments = string.split("&").map(s => s.split("="));
    var queryString = {};
    segments.forEach(s => queryString[s[0]] = s[1]);
    return queryString;
  }

  getAccessToken(): AccessToken {

    let accessToken = localStorage.getItem('token')

    if (accessToken && accessToken != 'in_progress') {
      let tokenObject = JSON.parse(accessToken)

      if (tokenObject && tokenObject.access_token) {
        return tokenObject.access_token
      }
    } else {
      return null
    }
  }

  tokenExpiresAt(): Date {
    let accessToken = localStorage.getItem('token')

    if (accessToken && accessToken != 'in_progress') {
      let tokenObject = JSON.parse(accessToken)

      if (tokenObject && tokenObject.expire_at) {
        return new Date(tokenObject.expire_at)
      }
    }
  }

  getRoleClaim(token): string[] {
    let access_token = jwt_decode(token)
    return access_token.roles
  }

  isLoggedIn(): boolean {
    return this.getAccessToken() != null
  }

  isLoginExpired(): boolean {
    let token_expire_at = this.tokenExpiresAt()
    return token_expire_at === undefined || token_expire_at === null || token_expire_at.getTime() < new Date().getTime()
  }

  isLoginGoingToExpireIn30min(): boolean {
    let token_expire_at = this.tokenExpiresAt()
    let current_date = new Date()
    const thirtyMinsInMs = 30 * 60 * 1000

    if (token_expire_at === undefined || token_expire_at === null) {
      return false
    }

    return (token_expire_at.getTime() - current_date.getTime() <= thirtyMinsInMs)
  }

  getRefreshToken(): string {
    let token = localStorage.getItem('token')

    if (token && token != 'in_progress') {
      let tokenObject = JSON.parse(token)

      if (tokenObject && tokenObject.refresh_token) {
        return tokenObject.refresh_token
      }
    } else {
      return null
    }


  }

  logout() {
        
    localStorage.removeItem('token')
    localStorage.removeItem('pkce_state')
    localStorage.removeItem('pkce_code_verifier')
    localStorage.removeItem('lab')
    
    this.redirectToLogoutPage()
  }

  redirectToLogoutPage() {
    window.location.href = environment.AZURE_LOGOUT_URL
  }

  /**
     * Redirect the UI to Azure AD login to provide credentials and consent.
     */
  redirectToAzureLogin() {

    let authUtil = new AuthUtil()
    let azureAuthUrl = environment.AZURE_AUTHORIZATION_URL
    let response_type = 'code'
    let client_id = environment.AZURE_BBUI_CLIENT_ID
    let state = authUtil.generateRandomString()
    localStorage.setItem("pkce_state", state);

    let prompt = 'login'

    let scope = authUtil.base64urlencode(environment.AZURE_AUTHORIZATION_SCOPE)//'openid%20profile%20User.Read%20email%20api%3A%2F%2F228d410f-af88-4d80-91d0-9674b672d415%2Faccess.ui'//'user.read%20openid%20profile%20api%3A%2F%2F84c32493-ba89-423e-8b6d-d6997421fad3%2Fbuild.info.authgrant'
    let redirect_uri = authUtil.base64urlencode(environment.AZURE_BBUI_REDIRECT_URL_AFTER_LOGIN)//'http%3A%2F%2Flocalhost%3A4200'

    let code_verifier = authUtil.generateRandomString();
    localStorage.setItem("pkce_code_verifier", code_verifier);

    //use sha256 to hash code_verifier
    let code_challenge = authUtil.sha256(code_verifier)//authUtil.base64urlencode(code_verifier) // ///'462d7acf7cbd940407fbd361f78e384e9f3e06dd2e9db743661abc97'
    let code_challenge_method = 'S256'

    //Redirect to Azure login
    window.location.href = `${azureAuthUrl}`
      + `?response_type=${response_type}`
      + `&client_id=${client_id}`
      + `&state=${state}`
      + `&prompt=${prompt}`
      + `&scope=${scope}`
      + `&redirect_uri=${redirect_uri}`
      + `&code_challenge=${code_challenge}`
      + `&code_challenge_method=${code_challenge_method}`
  }


  base64URLEncode(str) {
    return str.toString('base64')
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=/g, '');

  }

}


